<template>
  <div class="page">
    <header-el></header-el>

    <section class="page-hero">
      <div class="ui-container">
        <p class="crumb">首页 / 产品与服务</p>
        <h1>产品与服务</h1>
        <p class="lede">
          AIoT 智能终端产品线覆盖 AI 伙伴、智能教育、智能家居、宠物生活与行业终端，
          全部支持在线固件升级；配套 AIOT 服务与大模型服务，提供从硬件到 AI 的全栈能力。
        </p>
      </div>
    </section>

    <div class="ui-container">
      <div class="float-panel">
        <!-- 分类筛选 -->
        <div class="filter">
          <button
            v-for="c in productCategories"
            :key="c"
            class="filter__item"
            :class="{ 'is-active': current === c }"
            @click="current = c"
          >{{ c }}</button>
        </div>

        <!-- 产品栅格 -->
        <div class="grid">
          <div class="item" v-for="p in filteredProducts" :key="p.name">
            <div class="item__pic">
              <img :src="p.image" :alt="p.name" />
              <span class="tag" v-if="p.tag">{{ p.tag }}</span>
            </div>
            <h3>{{ p.name }}</h3>
            <p class="item__cat">{{ p.category }}</p>
            <p class="item__desc">{{ p.desc }}</p>
            <div class="item__ft">
              <span class="item__fw" v-if="p.firmware > 0">{{ p.firmware }} 个固件</span>
              <a class="item__go" href="https://upgrader.asstar.com/" target="_blank" rel="noopener noreferrer">在线升级 ↗</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 服务 -->
    <section class="section section--gray">
      <div class="ui-container">
        <div class="section-head">
          <span class="kicker">SERVICES</span>
          <h2>配套服务</h2>
          <p class="sub">硬件之上，服务加成</p>
        </div>
        <div class="svc-grid">
          <div class="svc card" v-for="s in serviceCards" :key="s.name">
            <span class="svc__en">{{ s.en }}</span>
            <h3>{{ s.name }}</h3>
            <p class="svc__desc">{{ s.desc }}</p>
            <ul class="check-list">
              <li v-for="pt in s.points" :key="pt">{{ pt }}</li>
            </ul>
            <router-link class="btn btn--primary svc__btn" :to="s.to">了解详情</router-link>
          </div>
        </div>
      </div>
    </section>

    <footer-el></footer-el>
  </div>
</template>

<script>
  import Header from "../components/header.vue";
  import Footer from "../components/footer.vue";
  import { productCategories, products, serviceCards } from "../data/site.js";

  export default {
    components: {
      "header-el": Header,
      "footer-el": Footer
    },
    data() {
      return {
        productCategories,
        products,
        serviceCards,
        current: "全部"
      };
    },
    computed: {
      filteredProducts() {
        if (this.current === "全部") return this.products;
        return this.products.filter(function (p) {
          return p.category === this.current;
        }, this);
      }
    }
  };
</script>

<style scoped>
  .filter {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 28px;
  }
  .filter__item {
    height: 38px;
    padding: 0 20px;
    border: none;
    border-radius: 999px;
    background: #f5f6f8;
    color: #4c515b;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.18s ease;
  }
  .filter__item:hover { color: #e8382f; background: #fdeceb; }
  .filter__item.is-active {
    background: #e8382f;
    color: #fff;
    font-weight: 600;
  }

  .grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }
  .item {
    border: 1px solid #f0e9e8;
    border-radius: 16px;
    padding: 22px;
    transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
  }
  .item:hover {
    transform: translateY(-3px);
    border-color: transparent;
    box-shadow: 0 14px 34px rgba(232, 56, 47, 0.12);
  }
  .item__hd {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }
  .item__pic {
    position: relative;
    aspect-ratio: 4 / 3;
    border-radius: 12px;
    overflow: hidden;
    background: #f7f8fa;
    border: 1px solid #f2f3f5;
  }
  .item__pic img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  .item__pic .tag {
    position: absolute;
    top: 10px;
    right: 10px;
  }
  .item h3 { margin-top: 14px; font-size: 16px; }
  .item__cat { margin-top: 2px; font-size: 12px; color: #e8382f; }
  .item__desc {
    margin-top: 8px;
    font-size: 13px;
    color: #8a909b;
    line-height: 1.7;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .item__ft {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 14px;
  }
  .item__fw { font-size: 12px; color: #8a909b; }
  .item__go {
    font-size: 13px;
    font-weight: 600;
    color: #e8382f;
  }
  .item__go:hover { color: #c42d1e; }

  .svc-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 22px;
  }
  .svc { padding: 34px 32px; }
  .svc__en {
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.16em;
    color: #e8382f;
  }
  .svc h3 { margin-top: 6px; font-size: 22px; }
  .svc__desc { margin-top: 10px; font-size: 14px; color: #4c515b; line-height: 1.8; }
  .svc .check-list { margin-top: 14px; }
  .svc__btn { margin-top: 22px; }

  @media (max-width: 1023px) {
    .grid { grid-template-columns: repeat(2, 1fr); }
    .svc-grid { grid-template-columns: 1fr; }
  }

  @media (max-width: 767px) {
    .grid { grid-template-columns: 1fr; }
    .svc { padding: 24px 20px; }
  }
</style>
